import React from 'react';
import IconInfoCircle from 'src/presentations/components/atom/icons/InfoCircle';
import IconDanger from 'src/assets/images/icons/danger-gray.svg';
import IconRefresh from 'src/assets/images/icons/refresh-gray.svg';
import IconCheckCircle from 'src/presentations/components/atom/icons/CheckCircle';
import WarningIcon from 'src/assets/images/icons/danger-light.svg';
import { OptionType } from './types';

interface ShipmentIconProps {
  type?: OptionType;
  status?: string;
  auditStatus?: string;
}

export const ShipmentIcon: React.FC<ShipmentIconProps> = ({ type, status, auditStatus }) => {
  if (type === 'RESOLVED' && (status === 'APPROVED' || auditStatus === 'APPROVED')) {
    return (
      <div className='w-20 h-20 rounded-full bg-[#00992B] relative'>
        <IconCheckCircle size={24} color='#CCEBD5' className='absolute -left-2 -top-2' />
      </div>
    );
  }

  if (type === 'RESOLVED' && (status === 'REJECTED' || auditStatus === 'REJECTED')) {
    return <img src={WarningIcon} alt='' />;
  }

  if (type === 'UNDER_REVIEW') {
    return (
      <div className='w-20 h-20 rounded-full relative'>
        <img src={IconDanger} alt='' />
      </div>
    );
  }

  if (type === 'PROCESSING') {
    return (
      <div className='w-20 h-20 rounded-full relative'>
        <img src={IconRefresh} alt='' />
      </div>
    );
  }

  return (
    <div className='w-20 h-20 rounded-full bg-[#606060] relative'>
      <IconInfoCircle size={24} color='#B9BABC' className='absolute -left-2 -top-2' />
    </div>
  );
};
